import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import OnlineMessagesEditor from './Editor';

export default function OnlineMessages({ itemTemplateFunc = null } = {}) {
    return createTaskType({
        id: 'online_messages',
        label: 'Online Messages',
        skill: 'reading_writing',
        v2: true,
        hasRubric: true,

        editor: OnlineMessagesEditor,
        createItemsTemplate: itemTemplateFunc || (() => [
            createOnlineMessagesImageItem({ isExample: true }), ...times(5, createOnlineMessagesImageItem)
        ]),

        convertToLocalFormat(task) {
            task = cloneDeep(task);
            task.items = task.items.map(item => {
                if (item.user_answer_stimulus_text !== null) {
                    item.phase = "IMAGE";
                } else if (item.answers[0].text !== undefined) {
                    item.phase = "TEXT";
                } else {
                    item.phase = "WRITING";
                }
                item.answers = item.answers.map(answer => {
                    if (Array.isArray(answer.training_sentences)) {
                        answer.training_sentences = answer.training_sentences.join(', ');
                    }
                    return answer;
                });
                return item;
            })
            return task;
        },

        convertToUploadFormat(task, { isNew }) {
            task = cloneDeep(task);
            task.items = task.items.map(item => {
                if (item.icon_indicator === 'Text') {
                    delete item.user_answer_stimulus_text;
                }
                item.answers = item.answers.map(answer => {
                    if (typeof answer.key === 'string') {
                        answer.key = answer.key.split(',').map(x => x.trim()).filter(x => !!x);
                    }
                    if (typeof answer.training_sentences === 'string') {
                        answer.training_sentences = answer.training_sentences
                            .split(',')
                            .map(x => x.trim())
                            .filter(x => !!x);
                    }
                    return answer;
                })
                return item;
            })
            return task;
        },

        getKeys: (item) => {
            return item.answers
                .filter(x => x.is_correct_answer)
                .map(x => `Option ${'ABC'[x.order - 1]} - ${x.key ? x.key.join(', ') : x.text ? x.text : x.image_id}`);
        }
    })
};

export function createOnlineMessagesImageItem({ isExample = false,  hasRubric = false } = {}) {
    return {
        is_example: isExample,
        ...((isExample || hasRubric) && {
            rubric_id: '',
        }),
        phase: 'IMAGE',

        /** @type {'Image' | 'Camera'} */
        icon_indicator: '',
        system_question: '',
        user_answer_stimulus_text: '',
        answers: times(3, () => ({
            is_correct_answer: false,
            image_id: '',
        })),
    }
}

export function createOnlineMessagesTextItem({ isExample = false, hasRubric = false } = {}) {
    return {
        is_example: isExample,
        ...((isExample || hasRubric) && {
            rubric_id: '',
        }),
        phase: 'TEXT',

        icon_indicator: 'Text',
        system_question: '',
        // Stimulus image id
        image_id: '',
        answers: times(3, () => ({
            is_correct_answer: false,
            text: '',
        })),
    }
}

export function createOnlineMessagesWritingItem({ isExample = false, hasRubric = false } = {}) {
    return {
        is_example: isExample,
        ...((isExample || hasRubric) && {
            rubric_id: '',
        }),
        phase: 'WRITING',

        icon_indicator: 'Text', // required by backend
        system_question: '',
        // Stimulus image id
        answers: times(3, () => ({
            is_correct_answer: true,  // backend required a value to be set.
            image_id: '',
            key: [],
            training_sentences: []
        })),
    }
}